module.exports = __webpack_public_path__ + "static/img/home-banners-mob-old.7efa24a9.jpg";